import { PromotionTypeDescriptionEnum } from 'app/shared/enums';

const FUNDRAISING_PROMOTION_CODE = 'FUNDRAISING';

export const isFundraisingPromotion = (value?: string): boolean =>
  value === FUNDRAISING_PROMOTION_CODE ||
  value === PromotionTypeDescriptionEnum.Fundraising;
